// imports
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../..';
import { msgFromError } from '../../../utils';
import { TEXTS } from '../../../../../constants';
import { WLQuestManager } from '../../../../web3';
import { config as CONFIG_API } from '../../../../api';
import { IQuestClaimBody, IQuestStartBody, IQuestState } from '../../../../web3/types';
import {
  completeQuest as COMPLETE_QUEST, setQuestTimer as SET_QUEST_TIMER,
  parseQuests, parseQuestProgress, scheduleQuestTimer, scheduleCompleteQuestTimeout
} from './helper';

// exports
export const completeQuest = COMPLETE_QUEST;
export const setQuestTimer = SET_QUEST_TIMER;
export const fetchQuestsProgress = createAsyncThunk(
  'user/quests/fetch',
  (_, { getState, dispatch, rejectWithValue }) => {
    let inProgressQuests: IQuestState[] = [];
    let campaignProgression = 0;
    const { config: { quests: metaQuests } } = getState() as RootState;
    return WLQuestManager.getCampaignProgression()
      .then((campaignProgressionP) => {
        campaignProgression = campaignProgressionP;
        return WLQuestManager.getPlayersQuests();
      })
      .then((inProgressQuestsP) => {
        inProgressQuests = inProgressQuestsP;
        const unavailableIds = inProgressQuests
          .filter((inProgressQuest) => !metaQuests[inProgressQuest.questId])
          .map((inProgressQuest) => inProgressQuest.questId);
        return CONFIG_API.fetchSideQuests(unavailableIds);
      })
      .then((unavailableQuestsP) => {
        const unavailableQuests = parseQuests(unavailableQuestsP);
        return parseQuestProgress({
          metaQuests, unavailableQuests, campaignProgression, inProgressQuests
        }, dispatch);
      })
      .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_FETCH_QUESTS)));
  },
  {
    condition: (_, { getState }) => {
      const {
        config: { fetchStatus: configFetchStatus },
        user: { quests: { fetchStatus: questProgressFetchStatus } }
      } = getState() as RootState;
      return (configFetchStatus === 'success' && questProgressFetchStatus !== 'loading');
    }
  }
);
export const startQuest = createAsyncThunk(
  'user/quests/start',
  (body: IQuestStartBody, { dispatch, rejectWithValue }) => WLQuestManager.startQuest(body)
    .then(({ startTime, endTime, rewardChances }) => {
      scheduleCompleteQuestTimeout(body.questId, endTime, dispatch);
      scheduleQuestTimer(body.questId, startTime, endTime, dispatch);
      return Promise.resolve({ startTime, endTime, rewardChances });
    })
    .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_START_QUEST))),
  {
    condition: (_, { getState }) => {
      const {
        config: { fetchStatus: configFetchStatus },
        user: { quests: { startId } }
      } = getState() as RootState;
      return (!startId && configFetchStatus === 'success');
    }
  }
);
export const claimRewards = createAsyncThunk(
  'user/quests/claim',
  (body: IQuestClaimBody, { rejectWithValue }) => WLQuestManager.claimRewards(body)
    .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_CLAIM_REWARDS))),
  {
    condition: (_, { getState }) => {
      const {
        config: { fetchStatus: configFetchStatus },
        user: { quests: { claimId } }
      } = getState() as RootState;
      return (!claimId && configFetchStatus === 'success');
    }
  }
);
export default {
  startQuest, completeQuest, claimRewards, setQuestTimer
};
